module.exports = "<p>\n  display-student works!\n</p>\n"